import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Select } from '../components/ui/Select';
import { roles } from '../utils/mockData';
import { Plus, Edit, Trash2, X, AlertCircle, Loader, CircleMinus, CirclePlus} from 'lucide-react';
import { useToast } from "../components/ui/toast-provider";

// Servicios
import { AuthService } from '../services/authService';

import LogoBlanco from '../components/img/LogoBlanco.png';

export function Tokens() {
  const [tokens, setTokens] = useState<any[]>([]);

  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  // Cargar cosas al montar el componente y cada vez que cambie el filtro
  useEffect(() => {
    getResumen();
  }, []);

  const getResumen = async () => {
    try {
      setError("");
      const res = await AuthService.getVerificaciones();
      setTokens(res.data);

      //console.log("Este es el resumen: ", res.data)

    } catch (err) {
      setError("Error al cargar empleados");
    } finally {
      setIsLoading(false);
    }

  }

  return (
    <div className="space-y-4 md:space-y-6">
      <div className="grid grid-cols-6 md:grid-cols-6 gap-4 p-6 text-white bg-primary border border-primary rounded-t-lg items-center">
        {/* Logo */}
        <div className="col-span-2 md:col-span-1 flex justify-center md:justify-start">
            <img 
            src={LogoBlanco} 
            alt="Logo AGEMI" 
            className="w-20 md:w-40 h-auto object-contain"
            />
        </div>
        <div className="col-span-4 md:col-span-5 flex flex-col text-sm md:text-base">
          <h1 className="text-3xl font-bold">Tokens</h1>
        <p className="text-base text-white mt-1 md:mt-2">
          Visualización de los Tokens de acceso activos en el sistema
        </p>
        </div>
      </div>

      <Card>
        <CardContent>
          {error && (
            <div className="p-4 mb-4 bg-destructive/10 border border-destructive rounded-lg text-destructive flex items-start gap-2">
              <AlertCircle className="w-5 h-5 mt-0.5 flex-shrink-0" />
              <div>
                <p className="font-semibold">Error al cargar tokens</p>
                <p className="text-sm">{error}</p>
              </div>
            </div>
          )}

          {isLoading ? (
            <div className="flex items-center justify-center py-8">
              <Loader className="w-6 h-6 animate-spin text-primary mr-2" />
              <p>Cargando tokens...</p>
            </div>
          ) : tokens.length === 0 ? (
            <div className="text-center py-8">
              <p className="text-muted-foreground">No hay tokens para mostrar</p>
            </div>
          ) : (
            <div className="overflow-auto max-h-[400px] border-gray-400 mb-10">
                <table className="min-w-full text-left">
                  <thead className="bg-primary text-white sticky top-0">
                    <tr>
                      <th className="px-3 md:px-4 py-2 md:py-3 text-left font-semibold">Token</th>
                      <th className="px-3 md:px-4 py-2 md:py-3 text-left font-semibold">Usuario</th>
                      <th className="px-3 md:px-4 py-2 md:py-3 text-left font-semibold">Empleado</th>
                      <th className="px-3 md:px-4 py-2 md:py-3 text-left font-semibold">Fecha de Expiración</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tokens.map((token, i = 0) => (
                      <tr key={i} className="border-t border-border hover:bg-muted/30 transition-colors">
                        <td className="px-3 md:px-4 py-2 md:py-3 text-xs md:text-sm font-semibold">{token.codigo}</td>
                        <td className="px-3 md:px-4 py-2 md:py-3 text-xs md:text-sm">{token.usuario}</td>
                        <td className="px-3 md:px-4 py-2 md:py-3 text-xs md:text-sm">{token.nombres} {token.apellidos}</td>
                        <td className="px-3 md:px-4 py-2 md:py-3 text-xs md:text-sm">
                            {new Date(token.fechaExpiracion).toLocaleString('es-GT', {
                              timeZone: 'America/Guatemala',
                              year: 'numeric',
                              month: '2-digit',
                              day: '2-digit',
                              hour: '2-digit',
                              minute: '2-digit',
                              second: '2-digit',
                            })}
                        </td>
                      </tr> 
                    ))}
                  </tbody>
                </table>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
